import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-box1-icon',
  templateUrl: './shopping-box1.component.html'
})
export class ShoppingBox1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
